import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getPersonalWorkloadAvailableColumns, getRealEstateClassList } from './api';

export const path = '/calculator-tariff/personal-workload/list';

const PagePersonalWorkload: React.FC = (props) => {
  const PersonalWorkload = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getPersonalWorkloadAvailableColumns,
      realEstateClasses: getRealEstateClassList,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <PersonalWorkload {...props} />;
};

export default PagePersonalWorkload;
